import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import { combineLatest, Observable, Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';

import { claimFnolQuery, DraftClaim, ReportClaimFnolService } from '@amfam/claim/fnol/data-access';
import { env } from '@amfam/environment';
// Store
import { PolicySelectors } from '@amfam/policy/data-access';
import { DockingBarService, LoadingSpinnerService, PageTitleService } from '@amfam/ui-kit';

import * as fromRoot from '../../../core/store';

@Component({
  selector: 'ds-report-claim-call-us',
  templateUrl: './report-claim-call-us.component.html',
  styleUrls: ['../report-claim-fnol.component.scss'],
  standalone: false
})
export class ReportClaimCallUsComponent implements OnInit, OnDestroy {
  private draftClaim: DraftClaim;
  public pageTitleName = 'File a Claim';
  contactNumber: string;

  // Shared Subject for completing all observables on destroy
  private stop$: Subject<void> = new Subject<void>();

  // Aggregate Loading Observable
  public loading: Observable<any>;

  public routeParams;
  public hasInjury = false;

  constructor(
    private route: ActivatedRoute,
    private pageTitle: PageTitleService,
    private dockingBarService: DockingBarService,
    private store: Store<fromRoot.RootState>,
    private reportClaimFnolService: ReportClaimFnolService,
    public spinner: LoadingSpinnerService
  ) {
    this.contactNumber = env.fnolContactNumberHref;
  }

  ngOnInit() {
    this.spinner.start({
      blockActions: true
    });

    // Aggregate loading spinner
    this.loading = combineLatest(
      this.store.select(PolicySelectors.selectPoliciesLoading),
      this.store.select(claimFnolQuery.getClaimFnolAnyLoading),
      (policiesLoading, fnolLoading) => {
        return policiesLoading || fnolLoading;
      }
    );
    // Fetch saved draft claim data from report-claim-risk-selection.comp.
    combineLatest(
      this.store.select(claimFnolQuery.getClaimFnolSelectedEntity),
      this.store.select(PolicySelectors.selectPolicies),
      this.loading,
      this.route.params,
      (draftClaim, policies, loading, routeParams) => {
        return {
          draftClaim: draftClaim,
          policies: policies,
          loading: loading,
          routeParams: routeParams
        };
      }
    )
      .pipe(
        takeUntil(this.stop$),
        filter(state => {
          return state && !state.loading;
        })
      )
      .subscribe(state => {
        this.spinner.stop();
        this.draftClaim = state.draftClaim;
        this.routeParams = state.routeParams;

        if (state.routeParams) {
          const reason = state.routeParams['reason'];
          if (reason === 'injury') {
            this.hasInjury = true;
          }
        }
        if (state.policies && this.draftClaim) {
          this.reportClaimFnolService.setClaimsPageTitle(
            state.policies.filter(policy => policy.policyNumber === this.draftClaim.policyNumber)[0]
          );
        } else {
          this.pageTitle.set('File a Claim');
          this.dockingBarService.registerHeading('File a Claim');
        }
      });
  }

  // onDestroy emit value and complete
  ngOnDestroy() {
    this.stop$.next();
    this.stop$.complete();
  }

  callUs() {
    window.open(this.contactNumber, '_blank');
  }
}
